import { QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import React from 'react';
import { applyMiddleware, legacy_createStore as createStore, compose, } from 'redux';
import logger from 'redux-logger';
import { featureFlags } from '../featureFlags';
import { queryClient } from '../services/api/query/queryClient';
import ChakraThemeProvider from '../styles/ChakraThemeProvider';
import { FeatureFlagProvider } from './FeatureFlagProvider';
import { SessionProvider } from './SessionProvider';
import { TokenProvider } from './TokenProvider';
import reducers from '../reducers';
const middleware = [thunkMiddleware];
if (process.env.NODE_ENV !== 'production') {
    middleware.push(logger);
}
const composeEnhancers = process.env.NODE_ENV !== 'production' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(...middleware)));
const Providers = ({ children }) => (React.createElement(Provider, { store: store },
    React.createElement(SessionProvider, null,
        React.createElement(FeatureFlagProvider, { flags: featureFlags },
            React.createElement(TokenProvider, null,
                React.createElement(ChakraThemeProvider, null,
                    React.createElement(QueryClientProvider, { client: queryClient }, children)))))));
export default Providers;
